<template>
  <div>
    <div class="block-title">Частота вполнения упражнений</div>

    <div class="portions">
      <div class="portions__count">
        <el-input v-model="activitiesData.schedule.quantity.value"
                  class="append"
                  placeholder="Введите название....">
          <div slot="suffix">{{ activitiesData.schedule.quantity.description }}</div>
        </el-input>
      </div>
      <div class="portions__count">
        <el-input v-model="activitiesData.schedule.duration.value"
                  class="append"
                  placeholder="Введите название....">
          <div slot="suffix">{{ activitiesData.schedule.duration.description }}</div>
        </el-input>
      </div>
    </div>

    <div class="block-title">Тип упражнений</div>
    <exercises-list :types="[]" :data-table="activitiesData.exercise" class="attention-zones"/>

    <el-table
        v-if="false"
        style="width: 100%"
        class="zebra-table types-table"
        :data="activitiesData.exercise"
        :show-header="false"
    >
      <el-table-column>
        <template scope="scope">
          <div class="types-table__title">
            <el-input v-if="editable && editIndex === scope.row.id"
                      v-model="scope.row.group"
                      type="textarea"
                      autosize/>
            <template v-else>{{ scope.row.group }}</template>
          </div>
        </template>
      </el-table-column>

      <el-table-column>
        <template scope="scope">
          <div class="types-table__unwanted unwanted">
            <div class="unwanted__title">
              <el-input v-if="editable && editIndex === scope.row.id"
                        v-model="scope.row.types"
                        type="textarea"
                        autosize/>
              <template v-else>{{ scope.row.types }}</template>

            </div>
            <div class="">

              <div @click="editIndex = scope.row.id" class="unwanted__edit"
                   :style="{ width: editable && editIndex === scope.row.id ? '38px' : ''}">
                <template v-if="editable && editIndex === scope.row.id">
                  <save-icon @click="save()" class="icon icon_black"/>
                  <i @click="deleteElement(scope.$index)" class="icon icon_black el-icon-delete"></i>
                </template>
                <i v-else @click="setEditableRow()" class="icon el-icon-edit"></i>
              </div>

            </div>
          </div>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import SaveIcon from "@/components/icons/Save"
import ExercisesList from "@/components/Exercises/List.vue"

export default {
  name: "Exercises",
  components: {
    SaveIcon,
    ExercisesList
  },
  data() {
    return {
      loading: false,
      editableSchedule: false,
      editable: false,
      editIndex: 0
    }
  },
  props: {
    activitiesData: {}
  },
  computed: {},
  methods: {
    setEditableSchedule() {

      this.editableSchedule = !this.editableSchedule
      this.$forceUpdate()

    },
    setEditableRow() {
      this.editable = true
      this.$forceUpdate()
    },
    updateSchedule() {
      console.log('next')
      this.loading = true;
    },
    save() {
      this.editable = false
      this.$emit('update')
    },
    deleteElement(index) {
      this.activitiesData.exercise.splice(index, 1)
      this.save()
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/zebra-table.scss";

.block-title {
  margin-top: 16px;

  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #111;
}

.portions {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 16px;

  &__count {
    width: 50%;
  }

}

.append /deep/ {
  .el-input__suffix {
    top: 10px;
  }

  .el-input__suffix-inner div {
    padding-right: 8px;
  }
}

.types-table {

  &__title {
    padding: 14px 0;

    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #111;

    white-space: pre-wrap;
  }

  &__recommended {
    font-size: 11px;
    line-height: 13px;
    color: #111;

    white-space: pre-wrap;
  }

  .unwanted {
    display: flex;

    justify-content: space-between;
    align-items: center;

    &__title {
      white-space: pre-wrap;

      width: 90%;
      font-size: 11px;
      line-height: 13px;
      color: #111;
    }

    &__edit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-left: 10px;

      font-size: 13px;
      line-height: 13px;
      color: #111;


    }

  }

  &__input {
    display: contents;

    /deep/ input {

      padding: 28px 7px;
      max-width: 99px;

      font-style: normal;
      font-weight: 600;
      font-size: 22px;
      line-height: 26px;
    }
  }


}

.attention-zones {
  margin-top: 16px;
}

</style>